var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMarketDataset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#171719"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6161 8.86612C27.25 9.23223 27.25 9.82149 27.25 11V27.25C27.25 28.4285 27.25 29.0178 27.6161 29.3839C27.9822 29.75 28.5715 29.75 29.75 29.75C30.9285 29.75 31.5178 29.75 31.8839 29.3839C32.25 29.0178 32.25 28.4285 32.25 27.25V11C32.25 9.82149 32.25 9.23223 31.8839 8.86612C31.5178 8.5 30.9285 8.5 29.75 8.5C28.5715 8.5 27.9822 8.5 27.6161 8.86612Z",
    fill: "#858B9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14.75C18.5 13.5715 18.5 12.9822 18.8661 12.6161C19.2322 12.25 19.8215 12.25 21 12.25C22.1785 12.25 22.7678 12.25 23.1339 12.6161C23.5 12.9822 23.5 13.5715 23.5 14.75V27.25C23.5 28.4285 23.5 29.0178 23.1339 29.3839C22.7678 29.75 22.1785 29.75 21 29.75C19.8215 29.75 19.2322 29.75 18.8661 29.3839C18.5 29.0178 18.5 28.4285 18.5 27.25V14.75Z",
    fill: "#858B9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1161 17.6161C9.75 17.9822 9.75 18.5715 9.75 19.75V27.25C9.75 28.4285 9.75 29.0178 10.1161 29.3839C10.4822 29.75 11.0715 29.75 12.25 29.75C13.4285 29.75 14.0178 29.75 14.3839 29.3839C14.75 29.0178 14.75 28.4285 14.75 27.25V19.75C14.75 18.5715 14.75 17.9822 14.3839 17.6161C14.0178 17.25 13.4285 17.25 12.25 17.25C11.0715 17.25 10.4822 17.25 10.1161 17.6161Z",
    fill: "#858B9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 32.5625C9.23223 32.5625 8.8125 32.9822 8.8125 33.5C8.8125 34.0178 9.23223 34.4375 9.75 34.4375H32.25C32.7678 34.4375 33.1875 34.0178 33.1875 33.5C33.1875 32.9822 32.7678 32.5625 32.25 32.5625H9.75Z",
    fill: "#858B9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketDataset);
export default __webpack_public_path__ + "static/media/icon-market-dataset.751dc9b0f993bcda1e6d34cb4f1e181f.svg";
export { ForwardRef as ReactComponent };